export default "__VITE_ASSET__mYFROOJn__"